/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
import matchSorter from 'match-sorter';
import React, { useRef, useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles, TextField, FormControl, Popper, Grid, CircularProgress } from '@material-ui/core';
import Autocomplete, { ListItemIcon } from './autocomplete';

import api from 'src/api/onboarding';

import Loader from 'src/images/loader1.gif';

import { getMe } from 'src/features/users/state/selectors';

const useStyles = makeStyles(() => ({
  container: {
    // marginTop: 16,
    // marginBottom: 8,
  },
  inputWrapper: {
    display: 'flex',
  },
  textHelper: {
    marginTop: 10,
  },
}));

const PhoneCountryDropdown = ({ countries, onChange, PopperComponent, size, value, onBlur, error, getCode, color }) => {
  const handleFilterOptions = (option, { inputValue }) => {
    return matchSorter(option, inputValue, { keys: Object.keys(option[0]) });
  };

  const handleRenderOption = option => (
    <>
      <ListItemIcon>+{option.country_code}</ListItemIcon>
      {option.country_name}
    </>
  );

  const handleRenderInput = params => (
    <TextField {...params} onBlur={onBlur} error={error} label="Country" variant="outlined" color={color} />
  );

  const handleChange = (event, option) => {
    onChange(option?.id);
    // getCode(filteredEle?.country_code);
  };

  const getOptionLabel = option => {
    return option && `+${option?.country_code}`;
  };

  const getValue = () => {
    return countries.filter(country => country.id === value).pop() ?? null;
  };

  return (
    <Autocomplete
      PopperComponent={PopperComponent}
      filterOptions={handleFilterOptions}
      options={countries}
      getOptionLabel={getOptionLabel}
      renderInput={handleRenderInput}
      renderOption={handleRenderOption}
      onChange={handleChange}
      // disableClearable
      autoHighlight
      size={size}
      value={getValue()}
    />
  );
};

const PhoneCountryDropdownByUser = ({ handleChangeCountry, value, size, data, onBlur, error, color, name, label }) => {
  const handleFilterOptions = (option, { inputValue }) => {
    return matchSorter(option, inputValue, { keys: Object.keys(option[0]) });
  };

  const handleRenderOption = option => (
    <>
      <ListItemIcon>+{option.country_code}</ListItemIcon>
      {option.country_name}
    </>
  );

  const handleRenderInput = params => (
    <TextField {...params} name={name} label={label} onBlur={onBlur} error={error} variant="outlined" color={color} />
  );

  const handleChange = (event, option) => {
    handleChangeCountry(option?.country_code);
  };

  const getOptionLabel = option => {
    return option && `+${option.country_code}`;
  };

  const getValue = () => {
    if (!value || !data) {
      return null;
    }

    let result = null;

    data.forEach(item => {
      if (item.country_code == value) {
        result = item;
      }
    });

    return result;
  }

  return (
    <Autocomplete
      filterOptions={handleFilterOptions}
      options={data}
      getOptionLabel={getOptionLabel}
      renderInput={handleRenderInput}
      renderOption={handleRenderOption}
      onChange={(event, option) => handleChange(event, option)}
      autoHighlight
      size={size}
      defaultValue={getValue}
    />
  );
};

const PhoneSelectDropdown = ({ onChange, onOpen, size, value, onBlur, label, error, options, status }) => {
  const types = ['Direct', 'Direct + Ext', 'Hunt Group'];

  const userData = useSelector(getMe);

  const filterOptions = (option, { inputValue }) => {
    return matchSorter(option, inputValue.replace('+', ''), { keys: ['country_code', 'area_code', 'number'] });
  };

  const renderOption = option => (
    <>
      <ListItemIcon>{types[option.type]}</ListItemIcon>
      {`+${option.country_code} ${option.area_code} ${option.number}`}
    </>
  );

  const renderInput = params => (
    <TextField
      {...params}
      onBlur={onBlur}
      error={error}
      label={label}
      variant="outlined"
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            {
              status === 'loading' && (
                userData?.customer?.is_subaccount === false
                  ? (<img alt="loader" src={Loader} />)
                  : (<CircularProgress sx={{ color: '#026de5', strokeLinecap: 'round' }} size={50} thickness={3} />)
              )
            }
            {params.InputProps.endAdornment}
          </>
        ),
      }}
    />
  );

  const handleChange = (event, option) => {
    onChange(option);
  };

  const getOptionLabel = option => {
    return option && `+${option.country_code} ${option.area_code} ${option.number}`;
  };

  const handleOpen = event => {
    onOpen();
  };

  return (
    <Autocomplete
      filterOptions={filterOptions}
      options={options}
      getOptionLabel={getOptionLabel}
      renderInput={renderInput}
      renderOption={renderOption}
      onChange={handleChange}
      autoHighlight
      size={size}
      value={value}
      onOpen={handleOpen}
      loading
    />
  );
};

const initialState = { code: '', value: '', countries: [] };

export default function PhoneInput({ user = false, country, name, countriesList, onChange, onBlur, error, value, size }) {
  const classes = useStyles();

  const containerRef = useRef();

  const [state, setState] = useState(initialState);

  const CustomPopper = props => (
    <Popper {...props} placement="bottom-start" style={{ width: containerRef.current.offsetWidth }} />
  );

  const countryValue = useMemo(() => state.countries.find(country => country.country_code === state.code)?.id, [state.code]);

  const handleChangeCountry = option => {
    const country = state.countries.find(country => country.id === option);

    const phoneCode = country?.country_code;

    setState({ ...state, code: phoneCode });
  };

  const handleChangePhone = event => {
    setState({ ...state, value: event.currentTarget.value });
  };

  useEffect(() => {
    if (user == 'true') {
      api.getCountriesListByUser().then(responce => {
        if (responce.data.status === 'success') {
          setState({
            ...state,
            countries: responce.data.data,
            code: value?.code ? value?.code : initialState.code,
            value: value.value ? value?.value : initialState.value,
          });
        }
      });
    } else {
      api.getCountriesList().then(responce => {
        if (responce.data.status === 'success') {

          setState({
            ...state,
            countries: responce.data.data,
            code: (value?.code) ? value.code : initialState.code,
            // eslint-disable-next-line no-nested-ternary
            value: (value?.value && value?.code)
              ? (
                (value.value.search(value.code) === 0)
                  ? value.value.slice(value.code.length)
                  : value.value
              )
              : initialState.value,
          });
        }
      });
    }
  }, []);

  useEffect(() => {
    onChange(name, `${state.code}${state.value}`, state.code, state.value);
  }, [state.code, state.value]);

  useEffect(() => {
    countriesList(state.countries);
  }, [state.countries]);

  return (
    <div className={classes.container} ref={containerRef}>
      <Grid container spacing={2}>
        {
          country && (
            <Grid item xs={12} md={3}>
              <PhoneCountryDropdown
                countries={state.countries}
                value={countryValue}
                PopperComponent={CustomPopper}
                onChange={handleChangeCountry}
                error={error}
                size={size}
              />
            </Grid>
          )
        }

        <Grid item xs={12} md>
          <FormControl variant="outlined" fullWidth>
            <TextField
              label="Enter your phone number"
              name={name}
              value={state.value}
              size={size}
              type="text"
              variant="outlined"
              onChange={handleChangePhone}
              onBlur={onBlur}
              error={error}
            />
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
}

export { PhoneCountryDropdownByUser, PhoneCountryDropdown, Autocomplete, ListItemIcon, PhoneSelectDropdown };

PhoneCountryDropdown.defaultProps = {};

PhoneInput.defaultProps = {
  onChange: () => { },
};

PhoneCountryDropdown.defaultProps = {
  onChange: () => { },
};

PhoneCountryDropdownByUser.defaultProps = {};

PhoneInput.defaultProps = {
  onChange: () => { },
};

PhoneCountryDropdownByUser.defaultProps = {
  onChange: () => { },
};
